module.exports = __webpack_public_path__ + "img/collection_active.ccb3db3c.png";